<template>
    <div>
      <Pos_promotion_new_detail/>
    </div>
  </template>
  
  <script>
  import Pos_promotion_new_detail from "@/components/adminArin/pos_system/warehouse/manage_promotion/Pos_promotion_new_detail";
  export default {
    name: "PosPromotionNewDetail",
    components: {
        Pos_promotion_new_detail
    }
  }
  </script>
  
  <style scoped>
  
  </style>
  